import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames'

import Icon from '~/core/scripts/components/Icon';
import { numberFormat } from '~/core/scripts/utils';
import { getPartyNameShort } from '~/scripts/config';
import { calculateSonstige, hexToRgb } from '~/scripts/utils';

class PartyBars extends PureComponent {
  static propTypes = {
    onClick: PropTypes.func,
    isClickable: PropTypes.bool,
    showComparison: PropTypes.bool,
    scaleToMax: PropTypes.bool,
    decimalPlaces: PropTypes.number
  }

  static defaultProps = {
    onClick: () => {},
    isClickable: false,
    showComparison: baseconfig.app.has2014Data,
    scaleToMax: false,
    decimalPlaces: 0
  }

  getHeight(item, maxValue, key) {
    if (!this.props.scaleToMax) {
      return item[key] * 2;
    }

    return (100 / maxValue) * item[key];
  }

  render() {
    const {
      items, isClickable, selectedParty,
      showComparison, onClick, areaId = ''
    } = this.props;
    const bars = items.slice(0, 6);
    const sonstige = calculateSonstige(bars);
    const maxValueRel = Math.max(...bars.map(d => d.valueRel));
    const maxValueComp = showComparison ? Math.max(...bars.map(d => d.valueRelComp)) : 0;
    const maxValue = Math.max(maxValueRel, maxValueComp);

    if (!items.length) {
      return null;
    }

    return (
      <div className="bars">
        {[...bars, sonstige].map((item) => {
          const barHeight = this.getHeight(item, maxValue, 'valueRel');
          const barHeightComp = this.getHeight(item, maxValue, 'valueRelComp');

          const barClasses = classnames(
            'bar__wrapper', {
              'is-clickable': isClickable,
              'is-active': selectedParty === item.name
            });

          const showClose = isClickable && selectedParty === item.name;
          const itemRgb = hexToRgb(item.color.max);

          return (
            <div
              key={`tooltip__bar-${item.name}`}
              className={barClasses}
              onClick={() => onClick(item.name)}
            >
              {showClose && (
                <div className="bar__close btn close">
                  <Icon type="close" />
                </div>
              )}

              <div className="bar__outer">
                <div
                  className="bar"
                  style={{
                    background: item.color.max,
                    height: `${barHeight}%`,
                    boxShadow: `0 3px 7px rgba(${itemRgb.rgbString}, 0.3)`
                  }}
                />
                {showComparison && (
                  <div
                    className="bar comparison"
                    style={{
                      background: item.color.max,
                      height: `${barHeightComp}%`,
                      boxShadow: `0 3px 7px rgba(${itemRgb.rgbString}, 0.3)`
                    }}
                  />
                )}
              </div>

              <div className="bar__party" style={{ color: item.color.max }}>
                {getPartyNameShort(item.name, areaId)}
              </div>
              <div className="bar__value">
                {numberFormat(item.valueRel, 1)}
              </div>
            </div>
          );
        })}
      </div>
    );
  }
}

export default PartyBars;
